import { __awaiter, __generator } from "tslib";
import { sendTransactionalMessage } from '@office-start/message-listener';
export function queryTrie(worker, _queryNumber, documents, text) {
    return __awaiter(this, void 0, void 0, function () {
        var responseMessage, trieQueryResultsMessage, indices;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!documents || !documents.length) {
                        return [2 /*return*/, documents];
                    }
                    return [4 /*yield*/, sendTransactionalMessage({
                            type: "query-trie" /* EdgeworthMessageType.QueryTrie */,
                            payload: {
                                query: text,
                            },
                        }, worker)];
                case 1:
                    responseMessage = _a.sent();
                    trieQueryResultsMessage = responseMessage === null || responseMessage === void 0 ? void 0 : responseMessage.data;
                    if (!trieQueryResultsMessage) {
                        return [2 /*return*/, []];
                    }
                    indices = trieQueryResultsMessage.payload.indices;
                    return [2 /*return*/, indices.map(function (index) { return documents[index]; })];
            }
        });
    });
}
//# sourceMappingURL=queryTrie.js.map